/** The validation codes of §5. Hosts localize from the code; the message here is the English default. */
export const FormulaErrorCodes = {
    ParseError: 'FL-E01',
    UnknownSymbol: 'FL-E02',
    BaseTypeMismatch: 'FL-E03',
    ValueTypeMismatch: 'FL-E04',
    NotAllowedInProfile: 'FL-E05',
    ResultTypeMismatch: 'FL-E06',
    PossiblyNullResult: 'FL-E07',
    ScaleExceedsTarget: 'FL-E08',
    LimitExceeded: 'FL-E09',
    /** Raised by the host over all formulas of one scope; a single formula cannot form a cycle on its own. */
    Cycle: 'FL-E10',
    UnitOrCurrencyMismatch: 'FL-E11',
    /** Warning: all() without a count() > 0 guard. Arrives with the aggregate functions. */
    AllWithoutCountGuard: 'FL-W01',
};
export function formulaError(code, span, message, params = {}) {
    return { code, span, message, params };
}
export function isWarning(error) {
    return error.code.startsWith('FL-W');
}
/** Carries a parse error out of the recursive descent; caught at the tryParse()/check() boundary, never escapes it. */
export class FormulaParseError extends Error {
    constructor(error) {
        super(error.message);
        this.error = error;
        this.name = 'FormulaParseError';
    }
}
